import React from 'react';
import $ from 'jquery';
import execAjax from '../../common/execAjax';
import getCookie from '../../common/getCookie';

class Counter extends React.Component {
    render() {
        if (this.props.status == 0) {
            return <span className="pull-right">connecting</span>
        } else {
            var minutes = Math.floor(this.props.duration / 60);
            var seconds = this.props.duration - minutes * 60;
            var zerofilled = ('00' + seconds).slice(-2);
            return (
                <span className="pull-right">{minutes}:{zerofilled}</span>
            )
        }
    }
}

class CallTile extends React.Component {
    render() {
        var bgclass = (this.props.call.status == 0) ? "tile-blink tile-active-call" : "tile-green tile-active-call";
        return (
            <div className={bgclass}>
                <div className="icon">
                    <i className="icon-phone"></i>
                </div>
                <div className="num">{this.props.call.called_id}  <Counter duration={this.props.call.duration} status={this.props.call.status}/></div>
                <h3>{this.props.call.descr}</h3>
                <p>{this.props.call.start_time}</p>
                <p>{this.props.call.caller_ip} > {this.props.call.called_ip}</p>
            </div>
        )
    }
}

class ActiveCallsContainer extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/dashboard/activecalls',
            calls: [],
            time: ''
        }
    }
    componentDidMount() {
        this.refreshInterval = setInterval(this.loadFromServer, 10000);
        this.loadFromServer();
        this.counterInterval = setInterval(this.increment, 1000);
        this.increment();
    }
    loadFromServer() {
        var data = [];
        var opt = {
            url: this.state.url,
            urlattrs: [],
            method: 'get',
            authToken: getCookie('sessid_admin')
        };
        var that = this;
        $.when( execAjax(data, opt) ).done(function(data) {
            that.setState({
                calls: data.calls,
                time: data.time
            });
        }).fail(function(result) {
            that.setState({
                error: result.msg
            });
        });
    }
    componentWillUnmount() {
        clearInterval(this.refreshInterval);
    }
    increment() {
        var newcalls = [];
        this.state.calls.map(function(call, i) {
            newcalls[i] = call;
            if (call.duration == undefined) {
                newcalls[i].duration = 1;
            } else {
                newcalls[i].duration = parseInt(call.duration) + 1;
            }
        }, this);
        this.setState({
            calls: newcalls
        });
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Active Calls</h2>
                    </div>
                </div>
                <div className="row">
                       {
                            this.state.calls.map(function(call, i) {
                                return (
                                    <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12" key={i}>
                                        <CallTile key={i} call={call} />
                                    </div>
                                )
                            }, this)
                        }
                </div>
            </div>
        )
    }
}

export default class extends React.Component{
    render() {
        return (
            <ActiveCallsContainer  />
        )
    }
}
